/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewEnumerationEvent } from './CRSFSecReviewEnumerationEvent';
import {
    CRSFSecReviewEnumerationEventFromJSON,
    CRSFSecReviewEnumerationEventFromJSONTyped,
    CRSFSecReviewEnumerationEventToJSON,
} from './CRSFSecReviewEnumerationEvent';
import type { CRSFSecReviewEnumerationStats } from './CRSFSecReviewEnumerationStats';
import {
    CRSFSecReviewEnumerationStatsFromJSON,
    CRSFSecReviewEnumerationStatsFromJSONTyped,
    CRSFSecReviewEnumerationStatsToJSON,
} from './CRSFSecReviewEnumerationStats';
import type { CRSFSecReviewIPDetails } from './CRSFSecReviewIPDetails';
import {
    CRSFSecReviewIPDetailsFromJSON,
    CRSFSecReviewIPDetailsFromJSONTyped,
    CRSFSecReviewIPDetailsToJSON,
} from './CRSFSecReviewIPDetails';

/**
 * 
 * @export
 * @interface CRSFSecReviewAggregatedEnumerationResult
 */
export interface CRSFSecReviewAggregatedEnumerationResult {
    /**
     * 
     * @type {Array<CRSFSecReviewEnumerationEvent>}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    events: Array<CRSFSecReviewEnumerationEvent>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    extra: Array<string>;
    /**
     * 
     * @type {{ [key: string]: CRSFSecReviewIPDetails; }}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    ip_details?: { [key: string]: CRSFSecReviewIPDetails; };
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    query: string;
    /**
     * 
     * @type {CRSFSecReviewEnumerationStats}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    stats: CRSFSecReviewEnumerationStats;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    total: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewAggregatedEnumerationResult
     */
    wildcards?: Array<string>;
}

/**
 * Check if a given object implements the CRSFSecReviewAggregatedEnumerationResult interface.
 */
export function instanceOfCRSFSecReviewAggregatedEnumerationResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "extra" in value;
    isInstance = isInstance && "query" in value;
    isInstance = isInstance && "stats" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function CRSFSecReviewAggregatedEnumerationResultFromJSON(json: any): CRSFSecReviewAggregatedEnumerationResult {
    return CRSFSecReviewAggregatedEnumerationResultFromJSONTyped(json, false);
}

export function CRSFSecReviewAggregatedEnumerationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewAggregatedEnumerationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CRSFSecReviewEnumerationEventFromJSON)),
        'extra': json['extra'],
        'ip_details': !exists(json, 'ip_details') ? undefined : (mapValues(json['ip_details'], CRSFSecReviewIPDetailsFromJSON)),
        'query': json['query'],
        'stats': CRSFSecReviewEnumerationStatsFromJSON(json['stats']),
        'total': json['total'],
        'wildcards': !exists(json, 'wildcards') ? undefined : json['wildcards'],
    };
}

export function CRSFSecReviewAggregatedEnumerationResultToJSON(value?: CRSFSecReviewAggregatedEnumerationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(CRSFSecReviewEnumerationEventToJSON)),
        'extra': value.extra,
        'ip_details': value.ip_details === undefined ? undefined : (mapValues(value.ip_details, CRSFSecReviewIPDetailsToJSON)),
        'query': value.query,
        'stats': CRSFSecReviewEnumerationStatsToJSON(value.stats),
        'total': value.total,
        'wildcards': value.wildcards,
    };
}

